module.exports = __webpack_public_path__ + "fonts/JDSansPro-Bold31db1482e9070512f3e86638ab606491.woff";